import React from 'react';
import Grid from '@material-ui/core/Grid';
import { INTERVIEW_TYPE_IDS } from 'features/sendouts/common/constants';
import strings from 'strings';
import InfoLabel from 'UI/components/molecules/InfoLabel';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';

import { formatInterviewDate } from './InterviewDetailsTabContent.utils';

const COPIES = strings.sendoutsV2.drawers.sendoutInterviewDetails;

export const InterviewDetailsTabContent = ({ details }) => {
  if (!details) return <EmptyPlaceholder title={COPIES.empty} />;

  const isFaceToFace = details.interviewTypeId === INTERVIEW_TYPE_IDS.FaceToFace;

  const fields = [
    {
      title: COPIES.details.scheduledTime,
      description: formatInterviewDate(details)
    },
    {
      title: COPIES.details.interviewType,
      description: details.interviewTypeTitle ?? '---'
    },
    {
      title: isFaceToFace ? COPIES.details.interviewAddress : COPIES.details.interviewLink,
      description: (isFaceToFace ? details.address : details.link) ?? '---'
    },
    {
      title: COPIES.details.otherInterviewers,
      description: details.otherInterviewer?.fullName ?? '---'
    },
    {
      title: COPIES.details.reminders,
      description: details.reminders ?? '---'
    }
  ];

  return (
    <Grid container spacing={2}>
      {fields.map(({ description, title }) => (
        <Grid item key={title} xs={6}>
          <InfoLabel title={title} description={description} mode="text" variant="body1" />
        </Grid>
      ))}
    </Grid>
  );
};
